import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JwtExpirationCheckerService {
  constructor() {}

  checkTokenExpiration(): string {
    const token = localStorage.getItem('auth0Token');

    if (!token) {
      console.log('No token found in localStorage.');
      return 'no_token';
    }

    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      console.log('Invalid JWT token format.');
      return 'invalid_token';
    }

    try {
      // JWT segments are base64url ('-' and '_'); atob() accepts only standard
      // base64 ('+' and '/') and throws InvalidCharacterError otherwise. Whether
      // a given token trips it depends on the byte content of its claims, so
      // this failed for some users and not others — and because the throw
      // happened before the exp comparison below, the expiry check never ran.
      const payload = JSON.parse(
        atob(tokenParts[1].replace(/-/g, '+').replace(/_/g, '/')),
      );
      const exp = payload.exp;

      if (!exp) {
        console.log('Token does not have an expiration field.');
        return 'invalid_token';
      }

      const expirationDate = new Date(exp * 1000); // exp is in seconds
      const currentDate = new Date();

      if (currentDate >= expirationDate) {
        console.log(`Token expired at ${expirationDate.toISOString()}`);
        return 'invalid_token';
      } else {
        console.log(
          `Token is valid. It will expire at ${expirationDate.toISOString()}`,
        );
        return 'valid_token';
      }
    } catch (error) {
      console.log('Error parsing the token payload:', error);
      return 'token_parsing_error';
    }
  }
}
